"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeat = void 0;
var repeat = function (repetitions) {
    return {
        it: function (title, fn) {
            for (var index = 1; index <= repetitions; index++) {
                // tslint:disable-next-line:no-only-tests
                it.only("".concat(title, " Run:").concat(index, "/").concat(repetitions), fn);
            }
        }
    };
};
exports.repeat = repeat;
//# sourceMappingURL=repeat.js.map